import { render, staticRenderFns } from "./ParcelSummary.vue?vue&type=template&id=3f8c0832&"
import script from "./ParcelSummary.vue?vue&type=script&lang=js&"
export * from "./ParcelSummary.vue?vue&type=script&lang=js&"
import style0 from "./ParcelSummary.vue?vue&type=style&index=0&id=3f8c0832&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports